<template v-resize="onResize">
  <div v-if="!$store.getters.getMobilePhoneActive" id="app">
    <v-app>
      <ErrorDialog></ErrorDialog>
      <v-container
        v-if="
          $store.getters.getMobilePhoneActive &&
            $store.getters.getCurrentAccountId
        "
      >
        <router-view :key="$route.fullPath" />
      </v-container>
      <v-container-mobile v-else-if="$store.getters.getCurrentAccountId">
        <router-view :key="$route.fullPath" />
      </v-container-mobile>
      <!--      <v-dialog ref="snackbarError" v-model="snackbarError" persistent max-width="500">-->
      <!--        <v-card class="error_dialog_class">-->
      <!--          <v-container>-->
      <!--            <v-layout row align-space-between justify-space-around fill-height>-->
      <!--              <v-layout align-space-between justify-space-between column class="mt-4 pl-4 ml-4">-->
      <!--                <h2 class="headline_error">Oops...</h2>-->
      <!--                <h3-->
      <!--                  v-if="$store.getters.getNoBackendConnection"-->
      <!--                  class="headline_error_2 mt-4"-->
      <!--                >{{$translate('ERROR_NO_CONNECTION')}}</h3>-->
      <!--                <h3 v-else class="headline_error_2 mt-4">{{$translate('ERROR_HEADER')}}</h3>-->
      <!--                <br>-->
      <!--                <h3 class="headline_error_2 mt-4">{{errorText}}</h3>-->
      <!--                <h3 v-if="errorCode!=''" class="headline_error_3">{{errorCode}}</h3>-->
      <!--                <v-layout align-end fill-height justify-end>-->
      <!--                  <v-btn-->
      <!--                    class="headline_error_btn text-capitalize"-->
      <!--                    flat-->
      <!--                    primary-->
      <!--                    right-->
      <!--                    @click="removeErrorMessage()"-->
      <!--                  >Close</v-btn>-->
      <!--                </v-layout>-->
      <!--              </v-layout>-->
      <!--            </v-layout>-->
      <!--          </v-container>-->
      <!--        </v-card>-->
      <!--      </v-dialog>-->
      <v-snackbar
        v-model="snackbarError"
        color="error"
        right
        class="snackbarError"
        multi-line
        vertical
        :timeout="5000"
      >
        <v-layout justify-center align-center column>
          <v-layout row>
            <v-icon dark medium>warning</v-icon>
            <h2>{{ $translate("ERROR") }}</h2>
          </v-layout>
          <p class="headline_error_2 textPadding">
            {{ errorText }} <b>{{ errorCode }}</b>
          </p>
          <!--         <p v-if="errorCode !=' '" class="headline_error_3"></p>-->
        </v-layout>
        <v-btn dark flat @click="snackbarError = false">
          {{ $translate("CLOSE") }}
        </v-btn>
      </v-snackbar>
      <v-snackbar
        color="primary"
        :auto-height="true"
        :timeout="timeout"
        :bottom="true"
        :middle="true"
        v-model="snackbar"
      >
        {{ text }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{
          $translate("CLOSE")
        }}</v-btn>
      </v-snackbar>
    </v-app>
    <v-layout row justify-center>
      <v-dialog
        v-model="showBlock"
        persistent
        content
        content-class="centered-dialog"
      >
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <h1>{{ errorBlock }}</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        ref="loadingDialog"
        v-model="showLoading"
        persistent
        content
        content-class="centered-dialog"
      >
        <v-container fill-height>
          <v-layout column justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="70"
              :width="7"
              :color="progressColor"
            ></v-progress-circular>
            <h1 v-if="message != null">{{ message }}</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <v-dialog v-model="updateBrowser" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">{{
          $translate("WEB_BROWSER_VERSION")
        }}</v-card-title>
        <v-card-text>
          {{ $translate("UPDATE_BROWSER_DETECTION") }}
          <br />
          {{ $translate("UPDATE_BROWSER_FAILS") }}
          <br />
          {{ $translate("UPDATE_BROWSER") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="updateBrowser = false">{{
            $translate("CANCEL")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <div v-else id="app">
    <v-app>
      <ErrorDialog></ErrorDialog>
      <v-container
        v-if="
          $store.getters.getMobilePhoneActive &&
            $store.getters.getCurrentAccountId
        "
      >
        <router-view :key="$route.fullPath" />
      </v-container>
      <v-container-mobile v-else-if="$store.getters.getCurrentAccountId">
        <router-view :key="$route.fullPath" />
      </v-container-mobile>
      <v-snackbar
        v-model="snackbarError"
        color="error"
        right
        class="snackbarError"
        multi-line
        vertical
        :timeout="5000"
      >
        <v-layout justify-center align-center column>
          <v-layout row>
            <v-icon dark medium>warning</v-icon>
            <h2>{{ $translate("ERROR") }}</h2>
          </v-layout>
          <p class="headline_error_2 textPadding">
            {{ errorText }} <b>{{ errorCode }}</b>
          </p>
          <!--         <p v-if="errorCode !=' '" class="headline_error_3"></p>-->
        </v-layout>
        <v-btn dark flat @click="snackbarError = false">
          {{ $translate("CLOSE") }}
        </v-btn>
      </v-snackbar>
      <v-snackbar
        color="primary"
        :auto-height="true"
        :timeout="timeout"
        :bottom="true"
        :middle="true"
        v-model="snackbar"
      >
        {{ text }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{
          $translate("CLOSE")
        }}</v-btn>
      </v-snackbar>
    </v-app>
    <v-layout row justify-center>
      <v-dialog
        v-model="showBlock"
        persistent
        content
        content-class="centered-dialogMobile"
      >
        <v-container fill-height>
          <v-layout row justify-center align-center>
            <h1>{{ errorBlock }}</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog
        ref="loadingDialog"
        v-model="showLoading"
        persistent
        content
        content-class="centered-dialogMobile"
      >
        <v-container fill-height>
          <v-layout column justify-center align-center>
            <v-progress-circular
              indeterminate
              :size="70"
              :width="7"
              :color="progressColor"
            ></v-progress-circular>
            <h1 v-if="message != null">{{ message }}</h1>
          </v-layout>
        </v-container>
      </v-dialog>
    </v-layout>
    <v-dialog v-model="updateBrowser" max-width="400" persistent>
      <v-card>
        <v-card-title class="headline">{{
          $translate("WEB_BROWSER_VERSION")
        }}</v-card-title>
        <v-card-text>
          {{ $translate("UPDATE_BROWSER_DETECTION") }}
          <br />
          {{ $translate("UPDATE_BROWSER_FAILS") }}
          <br />
          {{ $translate("UPDATE_BROWSER") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="updateBrowser = false">{{
            $translate("CANCEL")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ErrorDialog from "./components/ErrorDialog";
import { mapGetters } from "vuex";
import * as dssRequest from "@/api/dssRequest";
import BaseObject from "@/objects/BaseObject";
import OperationalScreen_BaseQuadrant from "@/components/OperationalScreen/OperationalScreen_BaseQuadrant";
import { websocket_helper } from "@/shared/websocket_helper";
import { setTimeout } from "timers";
import appConfig from "../config/app_config";
import { store } from "./store";
import UserObject from "./objects/UserObject";
import IncidentStoryBoard from "./components/IncidentStoryBoard";
const { detect } = require("detect-browser");
const browser = detect();

export default {
  name: "App",
  mixins: [websocket_helper],
  data() {
    return {
      sizeOfScreen: 0,
      activateObj: {},
      showBlock: false,
      errorBlock: "",
      block: false,
      discountCards: [],
      showLoading: false,
      message: "loading content...",
      progressColor: "purple",
      text: "",
      snackbar: false,
      snackbarError: false,
      errorText: "Error",
      errorCode: "",
      timeout: 6000,
      updateBrowser: false
    };
  },
  components: {
    ErrorDialog
  },
  computed: {
    ...mapGetters({
      AccountName: "getAccountName",
      userLevel: "auth/userLevel",
      customerPreferences: "getCustomerPreferences",
      AccountInfo: "getAccountInfo",
      currentAccountId: "getCurrentAccountId",
      userNotInAccountFlag: "getUserNotInFlag",
      _user: "auth/user"
    })
  },
  watch: {
    sizeOfScreen: function(newV, oldV) {
      if (newV <= 800) {
        this.$store.commit("setMobilePhoneActive", true);
      } else {
        this.$store.commit("setMobilePhoneActive", false);
      }
    },
    userLevel: function(newV, oldV) {
      if (newV > 0 && newV != oldV) {
        // user has logged in
        this.connect();
      } else if (newV != oldV && newV == 0) {
        this.disconnect();
      }
    },
    customerPreferences: {
      handler(data) {
        this.setCustomInfo(data);
      },
      deep: true
    },
    AccountInfo: {
      handler(data) {
        this.setCustomGeneraInfo(data);
      },
      deep: true
    },
    currentAccountId: function(newVal, oldVal) {
      if (newVal !== "") {
        this.connectTheWebSocketElements();
      }
    },
    userNotInAccountFlag: function(newVal, oldval) {
      if (newVal == true) {
        // this.block = true;
        //       this.activateLoader({
        //         show: true,
        //         message:
        //          " User does not exist within this account"
        //       });
        window.location.reload();
      }
    },
    $route(to, from) {}
  },
  created() {
    this.initFacebookSDK();
    this.initAppleAuth();
    this.getAccountInfo();
    // if  (!this.$store.getters.getCurrentAccountId) {
    //   this.getAccountId();
    // } else {
    //   this.loadDiscountCards();
    //   if (this.$store.getters.getSavePartnerId !== '') {
    //     this.checkIfPartnerExists();
    //   } else {
    //     if (this.customerPreferences.Primary_color == "") {
    //       if (this.$store.getters["auth/partnerId"] > 0) {
    //         // User is partner
    //         this.getPartnerPreferences();
    //       } else {
    //         // User is not a partner
    //         this.getAccountInfo(this.$store.getters.getCurrentAccountId);
    //       }
    //     }
    //   }
    // }
    if (window.innerWidth <= 800)
      this.$store.commit("setMobilePhoneActive", true);
    // handle the case where we don't detect the browser

    if (!this.$store.getters.getMobilePhoneActive) {
      if (browser) {
        this.$store.commit("setBrowserType", browser.name);
        if (
          browser.name != "chrome" &&
          browser.name != "firefox" &&
          browser.name != "safari"
        ) {
          // Don't do this for now
          // this.block = true;
          // this.activateLoader({
          //   show: true,
          //   message:
          //     browser.name +
          //     " is not supported! Please install Chrome/Firefox/Safari"
          // });
          return;
        }
        if (
          browser.name == "chrome" &&
          String(browser.version).substring(0, 2) < "74"
        ) {
          this.updateBrowser = true;
        }
      }
    }

    /*
     * Registering linsters
     */
    window.EventBus.listen(
      "recievingSignalToCreateEventWS",
      this.recievingSignalToCreateEventWS
    );
    window.EventBus.listen("activateLoader", this.activateLoader);

    window.EventBus.listen("activateSnackBar", this.activateSnackBar);
    window.EventBus.listen("disableErrorSnackBar", this.disableErrorSnackBar);
    // window.EventBus.listen("activateErrorDialog", this.activateErrorDialog);
    window.addEventListener("online", this.updateIndicator);
    window.addEventListener("offline", this.updateIndicator);

    /*
     * setup the signalObjectMap, created in websocket_helper component before it will try
     * connecting through the mounted phase
     */

    // Don't change Account preferences through websockets for now...

    // this.configurationProperties.signalObjectMap.set(this.currentAccountId, [
    //   ["AccountUpdate", ["AccountData"]]
    // ]);
    // if (this.$store.getters["auth/userLevel"])
    this.configurationProperties.profile.connect = true;

    this.updateIndicator();
    this.loadBaseAccountImages();
    window.EventBus.listen("getAccountId", this.getAccountId);
    window.EventBus.listen("getAccountInfo", this.getAccountInfo);
    window.EventBus.listen("getPartnerPreferences", this.getPartnerPreferences);
    window.EventBus.listen(
      "getTagDefUserGroupsAndSystemRoles",
      this.getTagDefUserGroupsAndSystemRoles
    );
  },
  beforeDestroy() {
    /*
     * Unregistering linsters
     */
    window.EventBus.removeListener("getAccountId", this.getAccountId);
    window.EventBus.removeListener(
      "recievingSignalToCreateEventWS",
      this.recievingSignalToCreateEventWS
    );
    window.removeEventListener("online", this.updateIndicator);
    window.removeEventListener("offline", this.updateIndicator);
    window.EventBus.removeListener("activateSnackBar", this.activateSnackBar);
    // window.EventBus.removeListener(
    //   "activateErrorDialog",
    //   this.activateErrorDialog
    // );
    window.EventBus.removeListener("activateLoader", this.activateLoader);
    window.EventBus.removeListener("getAccountInfo", this.getAccountInfo);
    window.EventBus.removeListener(
      "disableErrorSnackBar",
      this.disableErrorSnackBar
    );
    window.EventBus.removeListener(
      "getTagDefUserGroupsAndSystemRoles",
      this.getTagDefUserGroupsAndSystemRoles
    );
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    //to load colors on load
    //### wait for the accountId to be stored
    // this.getAccountInfo();
    // this.convertToB64();
    if (this.block) return;
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    initFacebookSDK() {
      console.log("created main");
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: "1816135695195986",
          autoLogAppEvents: true,
          xfbml: true,
          version: "v8.0"
        });
        window.FB.AppEvents.logPageView();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    },
    initAppleAuth() {
      const redirect =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? `:${window.location.port}` : "") +
        "/" +
        this.$store.getters.getRegion +
        "/login";
      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src =
          "//appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "appleAuth");
      setTimeout(() => {
        window.AppleID.auth.init({
          clientId: "nl.thedrivingforce.signIn",
          scope: "email",
          redirectURI: redirect,
          usePopup: true,
          state: "3/.3hZ8@A&x?_xh4@-[2GpL[mr.{nt"
        });
      }, 2000);
      console.log("Benjamin apple auth", {
        clientId: "nl.thedrivingforce.signIn",
        scope: "email",
        redirectURI: redirect,
        state: "3/.3hZ8@A&x?_xh4@-[2GpL[mr.{nt"
      });
    },
    connectTheWebSocketElements() {
      this.configurationProperties.signalObjectMap.set(
        appConfig.dss.eventAdminMng,
        [["routeAspectUpdate", ["RouteAspectData"]]]
      );
      this.configurationProperties.signalObjectMap.set(
        this.$store.getters.getAccountInfo.LocationId,
        [["locationAspectUpdate", ["LocationAspectData"]]]
      );
      this.configurationProperties.signalObjectMap.set(this.currentAccountId, [
        ["userLocationUpdate", ["userLocationData"]]
      ]);
      this.configurationProperties.signalObjectMap.set(
        this.currentAccountId + "_WeatherManager",
        [["weatherUpdate", ["WeatherData"]]]
      );
    },
    // getWeatherUpdates() {
    //   // websocket connection to get relay aspects
    //   let sigObjMap = new Map();
    //   sigObjMap.set(this.$store.getters.getCurrentAccountId + "_WeatherManager", []);
    //   sigObjMap
    //     .get(this.$store.getters.getCurrentAccountId + "_WeatherManager")
    //     .push(["weatherUpdate", ["WeatherData"]]);
    //   window.EventBus.fire("linkingToRecieveRoutes", sigObjMap);
    // },
    // getAllLocationAspects() {
    //     // websocket connection to get relay aspects
    //     let sigObjMap = new Map();
    //     sigObjMap.set(this.$store.getters.getAccountInfo.LocationId, []);
    //     sigObjMap
    //       .get(this.$store.getters.getAccountInfo.LocationId)
    //       .push(["locationAspectUpdate", ["LocationAspectData"]]);
    //     window.EventBus.fire("linkingToRecieveRoutes", sigObjMap);
    // },
    onResize() {
      this.sizeOfScreen = window.innerWidth;
    },
    // getAccountId() {
    //   //   const payload = {};
    //
    //   if (this.$store.getters.getRegion && this.$store.getters.getRegion !== "activateUser") {
    //     this.payload = {
    //       Region: this.$store.getters.getRegion
    //     };
    //   } else {
    //     //
    //     if (this.$route.path == "/activateUser") {
    //       //       this.payload = {
    //         Region: this.$route.query.AccountName
    //       }
    //     } else {
    //     this.payload = {
    //       Region: this.$route.params.account_id
    //     }
    //     }
    //   }
    //
    //   dssRequest.doRequest(
    //     response => {
    //       console.log("The call for getAccountId was successful", response);
    //       store.commit("setCurrentAccountId", response.data.AccountId);
    //       //       this.loadDiscountCards();
    //       if (this.$store.getters.getSavePartnerId !== '') {
    //         this.checkIfPartnerExists();
    //       } else {
    //         if (this.customerPreferences.Primary_color == "") {
    //           if (this.$store.getters["auth/partnerId"] > 0) {
    //             // User is partner
    //             this.getPartnerPreferences();
    //           } else {
    //             // User is not a partner
    //             this.getAccountInfo(response.data.AccountId);
    //             if (this.$route.path == "/activateUser") {
    //               this.confirmRegistration();
    //             }
    //           }
    //         }
    //       }
    //       if (this.$store.getters["auth/userName"] !== "") {
    //         this.checkUserAccountId()
    //       }
    //     },
    //     error => {
    //       console.log("The call for getAccountId was not successful", error);
    //       this.showBlockCondition({
    //         show: true,
    //         message: this.$translate("NO_ACCOUNT_ID")
    //       });
    //     },
    //     "getAccountId",
    //     appConfig.dss.accountManagerObjectId,
    //     this.payload
    //   );
    // },
    confirmRegistration() {
      this.activateObj = {};
      const userID = this.$route.query.UserID;
      store.commit("auth/setUserName", userID);
      const email = this.$route.query.email;
      const passwordHash = this.$route.query.token;
      const type = this.$route.query.type;
      const partnerId = this.$route.query.hasOwnProperty("PartnerId")
        ? this.$route.query.PartnerId
        : -1;
      console.log("partnerId partnerId partnerId", this.partnerId);
      this.activateObj = UserObject._createActivateUserObject(
        appConfig.login.clientSecret,
        email,
        userID,
        passwordHash,
        type,
        partnerId
      );

      dssRequest.doRequest(
        response => {
          if (response.value === 1) {
            store.commit("auth/setToken", response.data.access_token);
            store.commit("auth/setRefreshToken", response.data.refresh_token);
            this.activateObj.password = passwordHash;
            console.log("activateOBJ", this.activateObj);
            if (
              this.activateObj.hasOwnProperty("PartnerId") &&
              this.activateObj.PartnerId !== null &&
              this.activateObj.PartnerId > -1
            ) {
              this.$store.commit(
                "setSavePartnerId",
                Number(this.activateObj.PartnerId)
              );
              this.$store.commit("setRedirectedFromPearlCalendar", true);
              this.activateObj.PartnerId = Number(this.activateObj.PartnerId);
            }
            this.$store.commit("setUserActivationObject", this.activateObj);
            this.goTo("Login");
            // this.$router.push({
            //   name: "Login",
            //   params: {
            //     type: 'u',
            //     account_id: this.$store.getters.getRegion,
            //     data: this.activateObj
            //   }
            // })

            //   console.log("ok pushing to Calendar", this.activateObj)
            //   this.$router.push({
            //     name: "Calendar",
            //     params: {
            //       type: 'u',
            //       account_id: this.currentAccountId,
            //       partner_id: this.activateObj.PartnerId,
            //       data: this.activateObj
            //     }
            //   })
            // } else {
            //   console.log("ok NOT pushing to Calendar", this.activateObj)

            // this.$router.push({
            //   name: "Home",
            //   params: {
            //     type: 'u',
            //     account_id: this.currentAccountId,
            //     data: this.activateObj
            //   }
            // });
            // }
          }
        },
        error => {},
        "activateUser",
        store.getters.getCurrentAccountId,
        this.activateObj
      );
    },
    checkUserAccountId() {
      const payload = {
        RelationType: "User",
        Id: store.getters["auth/userName"],
        Types: {
          User: "User"
        },
        StructuredReply: true
      };
      dssRequest.doRequest(
        response => {
          let userData = response.data.UserData.User.celldata[0];
          if (userData == undefined) {
            console.log("ERROR! getUserData failed. userData is undefined.");
            this.logout();
          }
          if (
            userData != undefined &&
            userData[5] != store.getters.getCurrentAccountId
          ) {
            console.log(
              "ERROR! getUserData failed. CurrentAccountId doesnt match userData.",
              userData,
              store.getters.getCurrentAccountId
            );
            this.logout();
            this.$store.commit("auth/setUserLevel", 0);
          }
          console.log(
            "The call for getUserData in App was successful",
            response
          );
          this.$store.commit(
            "setUserLanguage",
            response.data.UserData.UserLanguage.LanguageTagId
          );
          window.EventBus.fire(
            "changeUserLanguage",
            response.data.UserData.UserLanguage.LanguageTagId
          );
        },
        error => {
          console.log(
            "The call for getUserData in App was not successful",
            error
          );
          this.logout();
          this.$store.commit("auth/setUserLevel", 0);
        },
        "getUserData",
        store.getters.getCurrentAccountId,
        payload,
        600000,
        false
      );
    },
    convertToB64() {
      const prefixPng = "data:image/png;base64,";
      const categories = [
        "Activities",
        "Beach",
        "Boat Tours",
        "Bridge",
        "Bus",
        "Cycling",
        "Drinking & Nightlife",
        "Eating",
        "Entertainment",
        "Ferry",
        "Forest",
        "Lighthouse",
        "Pickup-point",
        "POI",
        "Port",
        "Service Provider",
        "Shopping",
        "Sight",
        "Sights",
        "Sleeping"
      ];
      let markerImages = {};
      categories.forEach(categorie => {
        markerImages[
          categorie
        ] = require("./assets/Destination-states/categories/" +
          categorie +
          ".png");
      });
      this.$store.commit("setCategorieMarkers", markerImages);
    },
    recievingSignalToCreateEventWS(data) {
      console.log("data data", data);
      this.configurationProperties.signalObjectMap.set(data, [
        ["CapacityUpdate", ["CapacityData"]]
      ]);
      // this.configurationProperties.signalObjectMap.set(this.currentAccountId, [
      //   ["AccountUpdate", ["AccountData"]]
      // ]);
      // if (this.$store.getters["auth/userLevel"])
      this.configurationProperties.profile.connect = true;
    },
    checkIfPartnerExists() {
      // Action for loading all the Partners in the current account
      // TODO add possibility to add name to the url instead of number (using getPartners to check the table)
      let payload = {
        PartnerId:
          Number(this.$route.params.partner_id) != null
            ? Number(this.$route.params.partner_id)
            : -1
      };
      dssRequest.doRequest(
        response => {
          console.log("recieving the response", response);
          if (_.isEmpty(response.data)) {
            console.log(" AM I COMING HERE");
            this.showBlockCondition({
              show: true,
              message: this.$translate("NO_PARTNER_ID")
            });
          }
        },
        error => {
          console.log("the call for getPartner was not successful", error);
        },
        "getPartner",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    removeErrorMessage() {
      this.$store.commit("setNoBackendConnection", false);
      this.snackbarError = false;
    },
    getTagDefUserGroupsAndSystemRoles() {
      const payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        ReplyName: "getTagDefUserGroups",
        TableName: "config.TagDef",
        Columns: {
          AccountId: this.currentAccountId,
          Type: "User"
        }
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getTagDefUserGroupsAndSystemRoles was successful",
            response
          );
          const data = response.data.getTagDefUserGroups;
          for (let i = 0; i < data.celldata.length; i++) {
            if (data.celldata[i][1] == data.celldata[i][2]) {
              data.celldata.splice(i, 1);
              break;
            }
          }
          let userGroupForAccount = BaseObject._createArrayWithObjects(data);

          userGroupForAccount.sort((a, b) =>
            a.Description.localeCompare(b.Description, "en", {
              sensitivity: "base"
            })
          );
          userGroupForAccount.forEach(e => {
            if (
              this.$store.getters["auth/userLevel"] == 9 &&
              e.Type == "User" &&
              (e.Description == "Member" || e.Description == "Administrator")
            ) {
              e.Deletable = true;
              e.Editable = true;
            } else {
              e.Deletable = false;
              e.Editable = false;
            }
          });
          this.$store.commit("setUserGroupsForAccount", userGroupForAccount);
        },
        error => {
          console.log(
            "The generic call getTagDefUserGroupsAndSystemRoles was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );

      const userName = this.$store.getters["auth/userName"];
      // if (userName !== "") {
      //   this.getAllTags();
      //   this.getAllFields();
      // }
    },

    getAllFields(tags) {
      //This used to be the generic call getAllFilters
      const payload = {
        FunctionId: "TagsFunctionLibrary::getAllFilters",
        PartnerId: this.$store.getters["auth/partnerId"]
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call for getAllFilters was successful",
            response
          );
          delete response.data.ErrorMsg;
          const data = response.data.Filters.celldata;
          const tagGroupData = [];
          const newData = {};
          const tagGroups = {};
          // Creating the data for a tagGroup if the Description is not equal to the tagGroup
          for (let i = 0; i < data.length; i++) {
            if (data[i][2] == data[i][0]) {
              tagGroupData.push(data[i][2]);
            }
          }
          // Creating objects in an object with the name of a unique tagGroup
          for (const key of tagGroupData) {
            tagGroups[key] = {};
            for (let i = 0; i < data.length; i++) {
              if (key == data[i][0] && data[i][2] !== data[i][0]) {
                tagGroups[key][data[i][1]] = data[i][2];
              } else {
              }
            }
          }
          this.createFiltersStructure(tagGroups);
        },
        error => {
          console.log(
            "The generic call for getAllFilters was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },

    createFiltersStructure(response) {
      let filtersStructure = [];
      const colors = ["green", "indigo", "purple", "orange", "red", "teal"];
      let index = 0;
      if (response.hasOwnProperty("UserGroup")) {
        Object.keys(response.UserGroup).forEach(key => {
          if (response.UserGroup[key] === "Temporary Administrator")
            delete response.UserGroup[key];
        });
      }

      for (let [k, v] of Object.entries(response)) {
        let _tagsName = [];
        let color = colors[index++];
        for (let [k1, v1] of Object.entries(v)) {
          _tagsName.push({
            k: k1,
            v: v1,
            status: false,
            group: k,
            color: color
          });
        }
        filtersStructure.push({ status: false, title: k, entries: _tagsName });
      }
      this.$store.commit("setFilterTags", filtersStructure);
    },
    getAllTags() {
      if (this.$store.getters["auth/partnerId"] !== -1) {
        this.getPartnerPreferences();
      }
      const payload = {
        RelationType: "User",
        FunctionId: "TagsFunctionLibrary::getTagRelations",
        Id: this.$store.getters["auth/userName"],
        Types: {
          User: "User"
        },
        PartnerId: this.$store.getters["auth/partnerId"]
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call for getTagRelations(getTags) was successful",
            response
          );
          let tags = BaseObject._createArrayWithObjects(response.data.Tags);
          const tempAdministratorObject = tags.filter(
            e => e.Description === "Temporary Administrator"
          );
          if (tempAdministratorObject[0].Selected === "yes") {
            store.commit("auth/setTmpPartnerAdmin", true);
          }
          tags = tags.filter(e => e.Description !== "Temporary Administrator");
          this.$store.commit("setAllTags", tags);
        },
        error => {
          let userNotIn = "not in";
          if (error.errorMsg.includes(userNotIn)) {
            this.$store.dispatch("auth/logout");
            this.$store.commit("setUserNotInFlag", true);
          }
          console.log(
            "The generic call for getTagRelations(getTags) was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    logout() {
      console.log("LOGOUT");
      this.$store.dispatch("auth/logout");
      this.$store.commit("setUserIsCrowdScout", false);
      window.EventBus.fire("getAccountInfo", {});
      this.$store.commit("setRedirectedFromPearlCalendar", true);
      this.$router.push({
        name: "Homepage",
        params: {
          account_id: this.$store.getters.getRegion
        }
      });
      this.$store.commit("setVisitorActive", true);
      window.EventBus.fire(
        "activateSnackBar",
        this.$translate("USER_LOGGED_OUT")
      );
    },
    showBlockCondition(blockData) {
      this.showBlock = blockData.show;
      this.errorBlock = blockData.message;
    },
    onEvent(container) {
      if (container.Name === "routeAspectUpdate") {
        this.$store.commit("setRoutes", container.Data);
      }
      if (container.Name === "userLocationUpdate") {
        let vehicleLocations = Object.keys(container.Data).map(
          key => container.Data[key]
        );
        setTimeout(() => {
          window.EventBus.fire("transportVehicleUpdate", vehicleLocations);
        }, 1000);

        console.log("Fired transport update");
      }
      if (container.Name === "AccountUpdate") {
        const data = container.Data;
        if (data.AccountPreferences !== undefined) {
          this.parseAccountCustomerPreferencesWithStructure(
            data.AccountPreferences
          );

          // remove these data to do not interfere
          delete data.AccountPreferences;
        }
        this.$store.commit("setAccountInfo", this.AccountInfo);
      }
      if (container.Name === "weatherUpdate") {
        let weatherUpdates = Object.keys(container.Data).map(
          key => container.Data[key]
        );
        setTimeout(() => {
          // window.EventBus.fire("transportVehicleUpdate", vehicleLocations);
        }, 100);
      }
      if (
        container.Name === "locationAspectUpdate" &&
        container.Source === this.$store.getters.getAccountInfo.LocationId
      ) {
        // this.$store.commit("setRoutes", container.Data);
        this.$store.commit(
          "setMainLocationAspects",
          Object.keys(container.Data).map(key => container.Data[key])
        );
      }
    },
    updateIndicator(event) {
      if (event !== undefined) {
        if (event.type == "offline") {
          this.snackbarError = true;
          const e = this.$translateError("E_NE_001");
          this.errorText = e.error;
          this.errorCode = e.errorCode;
        } else {
          this.snackbarError = false;
        }
      }
    },
    activateLoader(loadingData) {
      this.showLoading = loadingData.show;
      this.message = loadingData.message;
    },
    activateSnackBar(message) {
      this.text = message;
      this.snackbar = true;
    },
    disableErrorSnackBar(message) {
      this.snackbarError = false;
    },
    activateErrorDialog(message) {
      // if (message == undefined) message = "E_SE_001";
      // this.snackbarError = true;
      // if (message.errorCode != undefined) {
      //   this.errorText = message.error;
      //   this.errorCode = message.errorCode;
      // } else {
      //   this.errorText = message;
      //   this.errorCode = "";
      // }
    },
    parseAccountCustomerPreferencesWithStructure(accountPreferences) {
      const result = BaseObject._createArrayWithObjects(accountPreferences);
      let currentAccountPreferencesObjects = result.map(
        ({ Key, Type, Value }) => ({
          Key,
          Type,
          Value
        })
      );
      this.$store.commit(
        "setCustomerPreferencesObjects",
        currentAccountPreferencesObjects
      );
      let prefs = {};
      currentAccountPreferencesObjects.map(e => (prefs[e.Key] = e.Value));
      this.$store.commit("setCustomerPreferences", prefs);
    },
    getAccountInfo(data) {
      // remove in case of not texel

      // if (this.$store.getters.getCurrentAccountId === '' && this.$store.getters.getRegion === '') {
      //   parent.location.href = "https://www.texel.net/nl/texelmap-app-downloaden";
      //   return;
      // }

      const payload = {};

      if (
        this.$store.getters.getRegion &&
        this.$store.getters.getRegion !== "activateUser"
      ) {
        this.payload = {
          Region: this.$store.getters.getRegion
        };
      } else {
        if (this.$route.path == "/activateUser") {
          this.payload = {
            Region: this.$route.query.AccountName
          };
        } else {
          this.payload = {
            Region: this.$route.params.account_id
          };
        }
      }
      dssRequest.doRequest(
        response => {
          console.warn("Account state ", response.data.AccountState);
          const state = response.data.AccountState;
          let currentAcountInfo = BaseObject._createArrayWithObjects(
            response.data.Account
          )[0];
          let result = BaseObject._createArrayWithObjects(
            response.data.AccountInfo
          );
          this.$store.commit("setCustomerPreferencesObjects", {});
          const currentAccountPreferencesObjects = result.map(
            ({ Key, Type, Value }) => ({ Key, Type, Value })
          );

          this.$store.commit(
            "setCustomerPreferencesObjects",
            currentAccountPreferencesObjects
          );
          // currentAcountInfo.Vat = {
          //   'None': {
          //     Name: 'Zero',
          //     Percentage: 0
          //   },
          //   'Low': {
          //     Name: 'Low',
          //     Percentage: 9
          //   },
          //   'High': {
          //     Name: 'High',
          //     Percentage: 21
          //   }
          // };
          console.log("Lorenzo response.data", response.data);
          this.$store.commit("setAccountVat", response.data.Vat);
          this.$store.commit("setAccountInfo", currentAcountInfo);
          if (!this.$store.getters.getRegion) {
            this.$store.commit("setRegion", currentAcountInfo.AccountName);
          }
          let prefs = {};
          currentAccountPreferencesObjects.map(e => (prefs[e.Key] = e.Value));
          this.$store.commit("setCustomerPreferences", prefs);
          this.$store.commit("setBackgroundImage", prefs.Background_image);
          // // check what you get
          if (data != null && data.user != undefined) {
            data.user.userlogin(
              r => {
                console.log("activateUser succesfull", data);
                this.$store.commit("setWebStepId", data.state);
                this.goTo("Homepage");
              },
              e => {
                console.log("activateUser error", e.errorMsg);
              }
            );
          }
          if (data != null && data.user != undefined)
            this.getTagDefUserGroupsAndSystemRoles();

          store.commit("setCurrentAccountId", currentAcountInfo.AccountId);
          console.log("Brian 212 currentAccountInfo", currentAcountInfo);

          if (currentAcountInfo.hasOwnProperty("LocationId")) {
            this.$store.commit(
              "setMainLocationId",
              currentAcountInfo.LocationId
            );
            this.getMainLocationData(currentAcountInfo.LocationId);
          }
          this.loadDiscountCards();
          if (this.$store.getters.getSavePartnerId !== "") {
            this.checkIfPartnerExists();
          } else {
            if (this.customerPreferences.Primary_color === "") {
              if (this.$store.getters["auth/partnerId"] > 0) {
                // User is partner
                this.getPartnerPreferences();
              } else {
                // User is not a partner
                if (this.$route.path == "/activateUser") {
                  this.confirmRegistration();
                }
              }
            }
          }
          if (this.$store.getters["auth/userName"] !== "") {
            this.checkUserAccountId();
          }
          window.EventBus.fire(
            "waitForAccountState",
            this.$store.getters.getAccountInfo.State
          );
        },
        error => {
          console.log("getAccountInfo error", error);
          if (
            error.data.ErrorMsg ===
              "AccountId is empty and Region is not in the request" ||
            error.data.ErrorMsg ===
              "Property [AccountId] could not be found in PropertyMap [AccountId]"
          ) {
            if (this.$route.path.includes("images")) {
              return;
            }
            this.showBlockCondition({
              show: true,
              message: this.$translate("NO_ACCOUNT_ID")
            });
            // if (this.$route.name !== 'ActivateUser'
            //  && this.$route.name !== 'Payments'
            //  && this.$route.name !== 'partnerConfirmation') {
            // parent.location.href = "https://texelmap.nl/texelmap";
            // }
          } else {
            this.showBlockCondition({
              show: true,
              message: this.$translate("maintenance")
            });
          }
          // if (this.$route.name !== 'ActivateUser' && this.$route.name !== 'Payments' ) {
          // parent.location.href = "https://texelmap.nl/texelmap";
          // }
        },
        "getAccountInfo",
        appConfig.dss.accountManagerObjectId,
        this.payload,
        payload,
        30000,
        false
      );
    },

    getPartnerPreferences() {
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"]
      };

      dssRequest.doRequest(
        response => {
          let result = BaseObject._createArrayWithObjects(
            response.data.PartnerPreferences
          );
          console.log(
            "getPartnerPreferences is called correctly with a response: ",
            response
          );
          const currentPartnerPreferencesObjects = result.map(
            ({ Key, Type, Value }) => ({ Key, Type, Value })
          );
          this.$store.commit(
            "setCustomerPreferencesObjects",
            currentPartnerPreferencesObjects
          );
          let prefs = {};
          currentPartnerPreferencesObjects.map(e => (prefs[e.Key] = e.Value));
          this.$store.commit("setCustomerPreferences", prefs);
          this.$store.commit("setBackgroundImage", prefs.Background_image);
          this.getAccount();
        },
        error => {
          console.log("getPartnerPreferences error", error);
        },
        "getPartnerPreferences",
        this.$store.getters.getCurrentAccountId,
        payload
      );
    },

    getAccount() {
      dssRequest.doRequest(
        response => {
          console.warn("Account state ", response.data.AccountState);
          const state = response.data.AccountState;

          let currentAcountInfo = BaseObject._createArrayWithObjects(
            response.data.Account
          )[0];
          this.$store.commit("setAccountInfo", currentAcountInfo);
        },
        error => {
          console.log("getAccountInfo error", error);
        },
        "getAccountInfo",
        appConfig.dss.accountManagerObjectId,
        {}
      );
    },
    getMainLocationData(id) {
      let payload = {
        LocationId: id,
        StructuredReply: true
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "- Called on App.vue - the call for `getLocationDetails on Main location` was successful",
            response
          );
          let focusCoordinates = [
            Number(response.data.Longitude),
            Number(response.data.Latitude)
          ];
        },
        error => {
          console.log(
            "- Called on App.vue - the call for `getLocationDetails on Main location` was successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GLD_001');
        },
        "getLocationData",
        id,
        payload,
        600000,
        false
      );
    },
    setCustomGeneraInfo(AccountInfo) {
      if (AccountInfo.State === "ACTIVATED") {
        this.activateLoader({ show: false, message: "" });
      } else if (AccountInfo.State === "DEACTIVATED") {
        this.activateLoader({
          show: true,
          message:
            "This account: " + this.currentAccountId + " has been deactivated"
        });
      }
    },
    setCustomInfo(customerPreferences) {
      this.$vuetify.theme.primary = customerPreferences.Primary_color;
      this.$vuetify.theme.secondary = customerPreferences.Secondary_color;
    },
    loadDiscountCards() {
      const payload = {};
      dssRequest.doRequest(
        response => {
          console.log("The call getDiscountCards was successful", response);
          this.discountCards = [];
          if (!_.isEmpty(response.data.DiscountCards)) {
            this.$store.commit("setDiscountCards", response.data.DiscountCards);
          } else {
            console.log(" recieved data is empty");
          }
        },
        error => {
          console.log("The call getDiscountCards was not successful", error);
        },
        "getDiscountCards",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    loadBaseAccountImages() {
      const prefixPng = "data:image/png;base64,";
      const prefixJpeg = "data:image/jpeg;base64,";
    },
    goTo(page, params = "component") {
      // Generic function to let the user move to other component
      this.$router.push({
        name: page,
        params: params
      });
    }
  }
};
</script>
<style>
.dialog.centered-dialog,
.v-dialog.centered-dialog {
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  height: 400px;
  width: 800px;
  color: whitesmoke;
}
.v-dialog.centered-dialogMobile {
  background: #282c2dad;
  box-shadow: none;
  border-radius: 6px;
  height: 40em;
  width: 800px;
  color: whitesmoke;
}

.error_dialog_class {
  border-radius: 1em !important;
  border-color: red !important;
  border: solid 0.2em;
}
.error_dialog_linda {
  height: 400px;
}
.headline_error {
  color: red;
  font-size: 32px;
  font-weight: bold;
}

.headline_error_3 {
  font-size: 32px;
  font-weight: bold;
}
.headline_error_btn {
  color: red !important;
  text-decoration: underline !important;
}
* {
  /* font-family: "Andale Mono";  /* tdf preffered font family */
  /* font-family: 'PT Sans', sans-serif; */
  font-family: "HelveticaNeue", "Helvetica";
}
.textPadding {
  padding-top: 1em;
  margin-bottom: 0;
}
.snackbarError .v-snack__wrapper .v-snack__content {
  height: 12em;
}
.snackbarError {
  opacity: 0.75;
}
</style>
